import { formatDate, formatDateTime, fillEmptyTxt } from "@zm-op/zmop-utils";

export default {
  formatDate,
  formatDateTime,
  fillEmptyTxt
};
